<template>
  <el-card class="card-main">
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="elementName">
        <el-input v-model="searchForm.elementName" placeholder="请输入巡查对象" clearable></el-input>
      </el-form-item>
      <el-form-item prop="riskLevel">
        <el-select v-model="searchForm.riskLevel" placeholder="请选择风险分级" filterable clearable>
          <el-option v-for="(item, index) in riskLevelList" :label="item.dicValue" :value="item.dicCode" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-show="$ButtonShow('ELE_ADD_01')">新增要素</el-button>
      <el-button @click="showOverview = true" type="primary" v-show="$ButtonShow('ELE_SEL_04')">要素总览</el-button>
    </div>

    <el-table class="global-table" v-loading="loading" :data="elementList">
      <el-table-column label="巡查对象" show-overflow-tooltip prop="elementName"></el-table-column>
      <el-table-column label="检查项数量" show-overflow-tooltip prop="standardNum" min-width="100"></el-table-column>
      <el-table-column label="风险等级" show-overflow-tooltip prop="riskLevelName"></el-table-column>
      <el-table-column label="操作" width="200px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.elementId)">查看</el-button>
          <el-button type="text" @click="onEdit(row.elementId)" v-show="$ButtonShow('ELE_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDelete(row.elementId)" v-show="$ButtonShow('ELE_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      @size-change="loadData"
      @current-change="loadData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </global-pagination>
    <Overview :showOverview.sync="showOverview"></Overview>
  </el-card>
</template>
<script>
import Overview from './Overview.vue'
import keepAlive from '@/mixins/keepAlive.js'
//
export default {
  name: 'elementList',
  mixins: [keepAlive],
  components: { Overview },
  data () {
    return {
      searchForm: {
        elementName: '',
        riskLevel: ''
      },
      riskLevelList: [],
      elementList: [],
      loading: false,
      showOverview: false,
      page: 1,
      size: 10,
      total: 0
    }
  },

  created () {
    this.loadRiskLevelList()
    this.loadData()
  },
  methods: {
    loadRiskLevelList () {
      this.$axios.get(this.$apis.common.selectDicByList, {
        dicType: 'riskLevel'
      }).then(res => {
        this.riskLevelList = res.riskLevel || []
      })
    },

    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.patrol.selectElementByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.elementList = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },

    onAdd () {
      this.$router.push({ name: 'patrolElementAdd' })
    },

    onEdit (elementId) {
      this.$router.push({ name: 'patrolElementEdit', params: { elementId } })
    },

    onDetail (elementId) {
      this.$router.push({ name: 'patrolElementDetail', params: { elementId } })
    },

    onDelete (elementId) {
      this.$confirm('确认删除该要素, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.patrol.deleteElement, {
          elementId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
